export default "__VITE_ASSET__0yQHKkCk__"